"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uuid = require("uuid");

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _Button = _interopRequireDefault(require("../button/Button"));

var _FileItem = _interopRequireDefault(require("./FileItem"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var audioIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z"
}));

var videoIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}));

var fileIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"
}));

var getFilePreview = function getFilePreview(file) {
  if (file.type.includes("video")) return videoIcon;else if (file.type.includes("audio")) return audioIcon;else if (file.type.includes("image")) return new Promise(function (resolve) {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function (e) {
      resolve(e.target.result);
    };
  });else return fileIcon;
};

var DxcFileInput = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? "file" : _ref$mode,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      buttonLabel = _ref.buttonLabel,
      dropAreaLabel = _ref.dropAreaLabel,
      _ref$helperText = _ref.helperText,
      helperText = _ref$helperText === void 0 ? "" : _ref$helperText,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      _ref$showPreview = _ref.showPreview,
      showPreview = _ref$showPreview === void 0 ? false : _ref$showPreview,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? true : _ref$multiple,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      callbackFile = _ref.callbackFile,
      value = _ref.value,
      margin = _ref.margin,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isDragging = _useState2[0],
      setIsDragging = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      files = _useState4[0],
      setFiles = _useState4[1];

  var _useState5 = (0, _react.useState)("file-input-".concat((0, _uuid.v4)())),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 1),
      fileInputId = _useState6[0];

  var colorsTheme = (0, _useTheme["default"])();
  var translatedLabels = (0, _useTranslatedLabels["default"])();

  var checkFileSize = function checkFileSize(file) {
    if (file.size < minSize) return translatedLabels.fileInput.fileSizeGreaterThanErrorMessage;else if (file.size > maxSize) return translatedLabels.fileInput.fileSizeLessThanErrorMessage;
  };

  var getFilesToAdd = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(selectedFiles) {
      var filesToAdd;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all(selectedFiles.map(function (selectedFile) {
                return getFilePreview(selectedFile);
              })).then(function (previews) {
                return selectedFiles.map(function (file, index) {
                  var fileInfo = {
                    file: file,
                    error: checkFileSize(file),
                    preview: previews[index]
                  };
                  return fileInfo;
                });
              });

            case 2:
              filesToAdd = _context.sent;
              return _context.abrupt("return", filesToAdd);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getFilesToAdd(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var addFile = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(selectedFiles) {
      var filesToAdd, finalFiles, fileToAdd;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!multiple) {
                _context2.next = 8;
                break;
              }

              _context2.next = 3;
              return getFilesToAdd(selectedFiles);

            case 3:
              filesToAdd = _context2.sent;
              finalFiles = [].concat((0, _toConsumableArray2["default"])(files), (0, _toConsumableArray2["default"])(filesToAdd));
              callbackFile === null || callbackFile === void 0 ? void 0 : callbackFile(finalFiles);
              _context2.next = 19;
              break;

            case 8:
              if (!(selectedFiles.length === 1)) {
                _context2.next = 14;
                break;
              }

              _context2.next = 11;
              return getFilesToAdd(selectedFiles);

            case 11:
              _context2.t0 = _context2.sent;
              _context2.next = 17;
              break;

            case 14:
              _context2.next = 16;
              return getFilesToAdd([selectedFiles[0]]);

            case 16:
              _context2.t0 = _context2.sent;

            case 17:
              fileToAdd = _context2.t0;
              callbackFile === null || callbackFile === void 0 ? void 0 : callbackFile(fileToAdd);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function addFile(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var selectFiles = function selectFiles(e) {
    var selectedFiles = e.target.files;
    var filesArray = Object.keys(selectedFiles).map(function (key) {
      return selectedFiles[key];
    });
    addFile(filesArray);
  };

  var onDelete = (0, _react.useCallback)(function (fileName) {
    var filesCopy = (0, _toConsumableArray2["default"])(files);
    var fileToRemove = filesCopy.find(function (file) {
      return file.file.name === fileName;
    });
    var fileIndex = filesCopy.indexOf(fileToRemove);
    filesCopy.splice(fileIndex, 1);
    callbackFile === null || callbackFile === void 0 ? void 0 : callbackFile(filesCopy);
  }, [files, callbackFile]);

  var handleClick = function handleClick() {
    document.getElementById(fileInputId).click();
  };

  var handleDrag = function handleDrag(e) {
    e.preventDefault();
    e.stopPropagation();
  };

  var handleDragIn = function handleDragIn(e) {
    var _e$dataTransfer$items;

    if (((_e$dataTransfer$items = e.dataTransfer.items) === null || _e$dataTransfer$items === void 0 ? void 0 : _e$dataTransfer$items.length) > 0) setIsDragging(true);
  };

  var handleDragOut = function handleDragOut(e) {
    // only if dragged items leave container (outside, not to childs)
    if (!e.currentTarget.contains(e.relatedTarget)) setIsDragging(false);
  };

  var handleDrop = function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    var filesObject = e.dataTransfer.files;

    if ((filesObject === null || filesObject === void 0 ? void 0 : filesObject.length) > 0) {
      var filesArray = Object.keys(filesObject).map(function (key) {
        return filesObject[key];
      });
      addFile(filesArray);
    }
  };

  (0, _react.useEffect)(function () {
    var getFiles = /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var valueFiles;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!value) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return Promise.all(value.map( /*#__PURE__*/function () {
                  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(file) {
                    var preview;
                    return _regenerator["default"].wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!file.preview) {
                              _context3.next = 4;
                              break;
                            }

                            return _context3.abrupt("return", file);

                          case 4:
                            _context3.next = 6;
                            return getFilePreview(file.file);

                          case 6:
                            preview = _context3.sent;
                            return _context3.abrupt("return", _objectSpread(_objectSpread({}, file), {}, {
                              preview: preview
                            }));

                          case 8:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x3) {
                    return _ref5.apply(this, arguments);
                  };
                }()));

              case 3:
                valueFiles = _context4.sent;
                setFiles(valueFiles);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function getFiles() {
        return _ref4.apply(this, arguments);
      };
    }();

    getFiles();
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.fileInput
  }, /*#__PURE__*/_react["default"].createElement(FileInputContainer, {
    margin: margin,
    name: name,
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(Label, {
    htmlFor: fileInputId,
    disabled: disabled
  }, label), /*#__PURE__*/_react["default"].createElement(HelperText, {
    disabled: disabled
  }, helperText), mode === "file" ? /*#__PURE__*/_react["default"].createElement(FileContainer, {
    singleFileMode: !multiple && files.length === 1
  }, /*#__PURE__*/_react["default"].createElement(ValueInput, {
    id: fileInputId,
    type: "file",
    accept: accept,
    multiple: multiple,
    onChange: selectFiles,
    name: name,
    disabled: disabled,
    readOnly: true,
    "aria-hidden": "true"
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    mode: "secondary",
    label: buttonLabel !== null && buttonLabel !== void 0 ? buttonLabel : multiple ? translatedLabels.fileInput.multipleButtonLabelDefault : translatedLabels.fileInput.singleButtonLabelDefault,
    onClick: handleClick,
    disabled: disabled,
    size: "fitContent",
    tabIndex: tabIndex
  }), files.length > 0 && /*#__PURE__*/_react["default"].createElement(FileItemListContainer, null, files.map(function (file, index) {
    return /*#__PURE__*/_react["default"].createElement(_FileItem["default"], {
      fileName: file.file.name,
      error: file.error,
      singleFileMode: !multiple && files.length === 1,
      showPreview: mode === "file" && !multiple ? false : showPreview,
      preview: file.preview,
      type: file.file.type,
      onDelete: onDelete,
      tabIndex: tabIndex,
      key: "file-".concat(index)
    });
  }))) : /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(ValueInput, {
    id: fileInputId,
    type: "file",
    accept: accept,
    multiple: multiple,
    onChange: selectFiles,
    name: name,
    disabled: disabled,
    readOnly: true,
    "aria-hidden": "true"
  }), /*#__PURE__*/_react["default"].createElement(DragDropArea, {
    isDragging: isDragging,
    disabled: disabled,
    mode: mode,
    onDrop: handleDrop,
    onDragEnter: handleDragIn,
    onDragOver: handleDrag,
    onDragLeave: handleDragOut
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    mode: "secondary",
    label: buttonLabel !== null && buttonLabel !== void 0 ? buttonLabel : translatedLabels.fileInput.dropAreaButtonLabelDefault,
    onClick: handleClick,
    disabled: disabled,
    size: "fitContent"
  }), mode === "dropzone" ? /*#__PURE__*/_react["default"].createElement(DropzoneLabel, {
    disabled: disabled
  }, dropAreaLabel !== null && dropAreaLabel !== void 0 ? dropAreaLabel : multiple ? translatedLabels.fileInput.multipleDropAreaLabelDefault : translatedLabels.fileInput.singleDropAreaLabelDefault) : /*#__PURE__*/_react["default"].createElement(FiledropLabel, {
    disabled: disabled
  }, dropAreaLabel !== null && dropAreaLabel !== void 0 ? dropAreaLabel : multiple ? translatedLabels.fileInput.multipleDropAreaLabelDefault : translatedLabels.fileInput.singleDropAreaLabelDefault)), files.length > 0 && /*#__PURE__*/_react["default"].createElement(FileItemListContainer, null, files.map(function (file, index) {
    return /*#__PURE__*/_react["default"].createElement(_FileItem["default"], {
      fileName: file.file.name,
      error: file.error,
      singleFileMode: false,
      showPreview: showPreview,
      preview: file.preview,
      type: file.file.type,
      onDelete: onDelete,
      tabIndex: tabIndex,
      key: "file-".concat(index)
    });
  }))), mode === "file" && !multiple && files.length === 1 && files[0].error && /*#__PURE__*/_react["default"].createElement(ErrorMessage, null, files[0].error)));
});

var FileInputContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  width: fit-content;\n"])), function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
});

var Label = _styledComponents["default"].label(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n"])), function (props) {
  return props.disabled ? props.theme.disabledLabelFontColor : props.theme.labelFontColor;
}, function (props) {
  return props.theme.labelFontFamily;
}, function (props) {
  return props.theme.labelFontSize;
}, function (props) {
  return props.theme.labelFontWeight;
}, function (props) {
  return props.theme.labelLineHeight;
});

var HelperText = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n"])), function (props) {
  return props.disabled ? props.theme.disabledHelperTextFontcolor : props.theme.helperTextFontColor;
}, function (props) {
  return props.theme.helperTextFontFamily;
}, function (props) {
  return props.theme.helperTextFontSize;
}, function (props) {
  return props.theme.helperTextFontWeight;
}, function (props) {
  return props.theme.helperTextLineHeight;
});

var FileContainer = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  ", "\n  margin-top: 0.25rem;\n"])), function (props) {
  return props.singleFileMode ? "flex-direction: row; column-gap: 0.25rem;" : "flex-direction: column; row-gap: 0.25rem;";
});

var ValueInput = _styledComponents["default"].input(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: none;\n"])));

var FileItemListContainer = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  row-gap: 0.25rem;\n"])));

var Container = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  row-gap: 0.25rem;\n  margin-top: 0.25rem;\n"])));

var DragDropArea = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  display: flex;\n  ", "\n  align-items: center;\n  width: 320px;\n  padding: ", ";\n  overflow: hidden;\n  box-shadow: 0 0 0 2px transparent;\n  border-radius: ", ";\n  border-width: ", ";\n  border-style: ", ";\n  border-color: ", ";\n  ", "\n  cursor: ", ";\n"])), function (props) {
  return props.mode === "filedrop" ? "flex-direction: row; column-gap: 0.75rem; height: 48px;" : "justify-content: center; flex-direction: column; row-gap: 0.5rem; height: 160px;";
}, function (props) {
  return props.mode === "filedrop" ? "calc(4px - ".concat(props.theme.dropBorderThickness, ") 1rem calc(4px - ").concat(props.theme.dropBorderThickness, ") calc(4px - ").concat(props.theme.dropBorderThickness, ")") : "1rem";
}, function (props) {
  return props.theme.dropBorderRadius;
}, function (props) {
  return props.theme.dropBorderThickness;
}, function (props) {
  return props.theme.dropBorderStyle;
}, function (props) {
  return props.disabled ? props.theme.disabledDropBorderColor : props.theme.dropBorderColor;
}, function (props) {
  return props.isDragging && "\n      background-color: ".concat(props.theme.dragoverDropBackgroundColor, ";\n      border-color: transparent;\n      box-shadow: 0 0 0 2px ").concat(props.theme.focusDropBorderColor, ";\n    ");
}, function (props) {
  return props.disabled && "not-allowed";
});

var DropzoneLabel = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 3;\n  text-align: center;\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n"])), function (props) {
  return props.disabled ? props.theme.disabledDropLabelFontColor : props.theme.dropLabelFontColor;
}, function (props) {
  return props.theme.dropLabelFontFamily;
}, function (props) {
  return props.theme.dropLabelFontSize;
}, function (props) {
  return props.theme.dropLabelFontWeight;
});

var FiledropLabel = _styledComponents["default"].span(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n"])), function (props) {
  return props.disabled ? props.theme.disabledDropLabelFontColor : props.theme.dropLabelFontColor;
}, function (props) {
  return props.theme.dropLabelFontFamily;
}, function (props) {
  return props.theme.dropLabelFontSize;
}, function (props) {
  return props.theme.dropLabelFontWeight;
});

var ErrorMessage = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  margin-top: 0.25rem;\n"])), function (props) {
  return props.theme.errorMessageFontColor;
}, function (props) {
  return props.theme.errorMessageFontFamily;
}, function (props) {
  return props.theme.errorMessageFontSize;
}, function (props) {
  return props.theme.errorMessageFontWeight;
}, function (props) {
  return props.theme.errorMessageLineHeight;
});

var _default = DxcFileInput;
exports["default"] = _default;